<template>

  <day-base-bar>

    <v-progress-linear :model-value="item.spacesSold" :max="item.spacesTotal" class="fill-height" :color="Object.keys(item.blackouts).length ? '#787878' : item.color" :bg-color="Object.keys(item.blackouts).length ? '#787878' : item.color" bg-opacity="0.4">
      {{ item.locationProduct.product.name }}
      ({{ item.spacesSold }}/{{ item.spacesTotal }})
    </v-progress-linear>

  </day-base-bar>

</template>

<script setup lang="ts">

import DayBaseBar from './DayBaseBar.vue'
import type { DayNormalInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: DayNormalInventoryCalendarItem
}

defineProps<Props>()

</script>
